import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import {FiArrowRight} from "react-icons/fi";

const ServiceList = [
    {
        image: '/images/services/cta-img-1.png',
        title: 'Mobile Solutions',
        description: 'With Mixon, you can transform your fantasy business app into a reality with ease and comfort.',
        link: "#"
    },
    {
        image: '/images/services/web_sol.svg',
        title: 'Web Solutions',
        description: 'At Mixon Softwares, we offer pixel perfect and responsive web solutions which are built around aesthetics and usability.',
        link: "#"
    },
    {
        image: '/images/services/faq.svg',
        title: 'Marketing Solutions',
        description: 'A cost-effective method is to hire digital marketing experts as an extra marketing resource to share your effort. We are experts.',
        link: "#"
    }
]
const ServiceFive = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
            {ServiceList.map((val, i) => (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 d-flex" key={i}>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}>
                        <div className={`service h-100 d-flex flex-column justify-content-between text-center ${serviceStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="image">
                                    <img src={`${val.image}`} alt="Service Images"/>
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link>
                                    </h4>
                                    <p className="description" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                </div>
                            </div>
                            <div className="button-group">
                                <a className="btn-default btn-small" href={val.link}>
                                    Read More <i className="icon"><FiArrowRight/></i>
                                </a>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceFive;